import React from 'react';

interface Props {
  onSave:    () => void;
  onDiscard: () => void;
  onCancel:  () => void;
}

const UnsavedChangesDialog: React.FC<Props> = ({ onSave, onDiscard, onCancel }) => (
  <div className="layers-overlay">
    <div className="param-dialog" style={{ maxWidth: 380 }}>
      <div className="param-title" style={{ color: '#ffaa44' }}>Unsaved Changes</div>
      <p style={{ margin: '12px 0', fontSize: 13, lineHeight: 1.6 }}>
        The current project has unsaved changes.<br />
        Do you want to save them before continuing?
      </p>
      <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
        <button style={{ flex: 1 }} onClick={onSave}>
          Save
        </button>
        <button style={{ flex: 1 }} onClick={onDiscard}>
          Don't save
        </button>
        <button style={{ flex: 1 }} onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default UnsavedChangesDialog;
